module.exports = __webpack_public_path__ + "static/media/pic_3.8796fde5.jpg";